<script setup>
const slots = useSlots()
const isHasSlotContent = computed(() => !!slots?.content)
</script>

<template>
  <Popper hover>
    <slot />
    <template #content="props">
      <slot name="content" v-bind="props" />
    </template>
  </Popper>
</template>

<style lang="scss" scoped></style>
